(function () {
  var STORAGE_KEY = 'desicolor_google_reviews_trust_v1';
  var SCROLL_MIN = 220;
  var MIN_VISIBLE_MS = 5000;

  function getData() {
    var el = document.getElementById('google-reviews-trust-data');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function pickRandom(arr, n) {
    if (!arr.length) return [];
    var copy = arr.slice();
    var out = [];
    var count = Math.min(n, copy.length);
    for (var i = 0; i < count; i++) {
      var j = Math.floor(Math.random() * copy.length);
      out.push(copy.splice(j, 1)[0]);
    }
    return out;
  }

  function renderQuotes(container, items) {
    container.innerHTML = '';
    items.forEach(function (item) {
      var p = document.createElement('p');
      p.className = 'google-reviews-trust__quote';
      p.textContent = '"' + (item.quote || '').trim() + '"';
      if (item.author && String(item.author).trim()) {
        var cite = document.createElement('cite');
        cite.textContent = '— ' + String(item.author).trim();
        p.appendChild(cite);
      }
      container.appendChild(p);
    });
  }

  function dismiss(root) {
    if (!root || root.classList.contains('is-dismissed')) return;
    root.classList.add('is-dismissed');
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
    setTimeout(function () {
      document.documentElement.classList.add('google-reviews-trust--gone');
    }, 500);
  }

  function init() {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        document.documentElement.classList.add('google-reviews-trust--gone');
        return;
      }
    } catch (e) {}

    var root = document.querySelector('[data-google-reviews-trust]');
    if (!root) return;

    var all = getData();
    var count = parseInt(root.getAttribute('data-quote-count') || '3', 10) || 3;
    var quotesWrap = root.querySelector('[data-quotes]');
    if (quotesWrap && all.length) {
      renderQuotes(quotesWrap, pickRandom(all, count));
    }

    var dismissed = false;
    var visibleSince = Date.now();
    function onScroll() {
      if (dismissed) return;
      var longEnough = Date.now() - visibleSince >= MIN_VISIBLE_MS;
      if (window.scrollY > SCROLL_MIN && longEnough) {
        dismissed = true;
        window.removeEventListener('scroll', onScroll, { passive: true });
        dismiss(root);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
